<template>
  <div>
    <Breadcrumb msg1="商品库存" msg2="库存与预警" />
    <el-card>
      <el-row :gutter="10" style="margin-bottom: 10px">
        <el-col :span="6"><el-input v-model="query.keyword" placeholder="商品名/SKU编码" clearable></el-input></el-col>
        <el-col :span="4">
          <el-checkbox v-model="lowOnly" @change="search">只看预警</el-checkbox>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-col>
      </el-row>
      <el-alert v-if="alerts.length > 0" :title="'库存预警：共 ' + alerts.length + ' 个SKU低于预警线'" type="error" :closable="false" show-icon style="margin-bottom: 10px"></el-alert>
      <el-table :data="list" border :row-class-name="rowClass">
        <el-table-column label="ID" prop="skuId" width="60"></el-table-column>
        <el-table-column label="商品" prop="productName" width="180"></el-table-column>
        <el-table-column label="规格" prop="specJson"></el-table-column>
        <el-table-column label="SKU编码" prop="skuCode" width="140"></el-table-column>
        <el-table-column label="当前库存" prop="stock" width="100">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.stock <= scope.row.minStock ? '#F56C6C' : '' }">{{ scope.row.stock }}</span>
          </template>
        </el-table-column>
        <el-table-column label="预警线" prop="minStock" width="100"></el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px" :current-page="query.page" :page-sizes="[10, 20, 50]" :page-size="query.limit" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="sizeChange" @current-change="pageChange"></el-pagination>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  components: { Breadcrumb },
  data () {
    return {
      query: { page: 1, limit: 10, keyword: '', lowOnly: false },
      list: [],
      total: 0,
      lowOnly: false,
      alerts: []
    }
  },
  created () {
    this.getData()
    this.$axios.http.get('/inventory/alerts', { params: { limit: 100 } }).then(r => {
      if (r.data.status === 200) this.alerts = r.data.data || []
    })
  },
  methods: {
    getData () {
      this.query.lowOnly = this.lowOnly
      this.$axios.get('/inventory', res => {
        this.list = res.data.records || []
        this.total = parseInt(res.data.total) || 0
      }, this.query)
    },
    search () { this.query.page = 1; this.getData() },
    sizeChange (s) { this.query.limit = s; this.getData() },
    pageChange (p) { this.query.page = p; this.getData() },
    rowClass ({ row }) {
      return row.stock <= row.minStock ? 'low-stock-row' : ''
    }
  }
}
</script>

<style scoped>
::v-deep .low-stock-row {
  background-color: #fef0f0;
}
</style>
